import { Pagination, Spin, Tabs } from 'antd';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Axis,
  Chart,
  Coord,
  Geom,
  Guide,
  Label,
  Legend,
  Shape,
  Tooltip
} from 'bizcharts';
import { routerRedux } from 'dva/router';
import { DataSet } from '@antv/data-set';
import { PATH_HOME } from '../../utils/constants';


export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ roomAbnormallyDetails, loading, intl, dispatch }) => {
    const {
      chartData,
      roomSummary = {},
      cancelRoomAbnormal = [],
      earlyEndRoomAbnormal = [],
      extendRoomAbnormal = [],
      normalRoomAbnormal = [],
      pageTotals = 0,
      pageSize = 0,
      pageCurrent = 0
    } = roomAbnormallyDetails;
    const {
      bookNum = 0,
      cancelNum = 0,
      earlyEndNum = 0,
      extendNum = 0,
      zoneName = '',
      roomName = ''
    } = roomSummary;
    let normalNum = bookNum - (cancelNum + earlyEndNum + extendNum);
    const { Html } = Guide;
    const chartTop = () => {
      let data = [];
      for (let item in chartData) {
        let obj = {
          day: item
        };
        obj[intl.formatMessage({ id: 'booking_number' })] =
          chartData[item].bookNum;
        obj[intl.formatMessage({ id: 'expire_number' })] =
          chartData[item].expireNum;
        data.push(obj);
      }
      const ds = new DataSet();
      const dv = ds.createView().source(data);
      dv.transform({
        type: 'fold',
        fields: [
          intl.formatMessage({ id: 'booking_number' }),
          intl.formatMessage({ id: 'expire_number' })
        ], // 展开字段集
        key: 'num', // key字段
        value: 'times' // value字段
      });
      const cols = {
        day: {
          range: [0, 1]
        }
      };
      // const itemTplChart= '<li data-index={index}>'
      //   + '<span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>'
      //   + intl.formatMessage({id:"report_booking_rate"})+': {value}'
      //   + '</li>'+ '<li data-index={index}>'
      //   + '<span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>'
      //   + intl.formatMessage({id:"report_disuse_rate"})+': {value}'
      //   + '</li>';
      return (
        <div className="roomChart">
          <div className="roomDetailTitle">
            {intl.formatMessage({ id: 'report_booking_disuse_info' })}
          </div>
          <div style={{ marginTop: '30px' }}>
            <Chart
              height={320}
              data={dv}
              scale={cols}
              forceFit
              padding={[10, 60, 80, 60]}
            >
              <Legend textStyle={{ fill: '#333' }} />
              <Axis
                name="day"
                label={{ textStyle: { fill: '#333', textAlign: 'center' } }}
              />
              <Axis name="times" label={{ textStyle: { fill: '#333' } }} />
              <Tooltip
                crosshairs={{ type: 'y' }}
                // itemTpl={itemTplChart}
              />
              <Geom type="line" position="day*times" size={2} color={'num'} />
              <Geom
                type="point"
                position="day*times"
                size={4}
                shape={'circle'}
                color={'num'}
                style={{ stroke: '#333', lineWidth: 1 }}
              />
            </Chart>
          </div>
        </div>
      );
    };
    // const itemTpl= '<li data-index={index}>'
    //   + '<span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>'
    //   + intl.formatMessage({id:"report_booking_rate"})+': {value}'
    //   + '</li>';

    const chartBottom = () => {
      let data = [];
      for (let item in chartData) {
        let obj = { day: item };
        obj[intl.formatMessage({ id: 'used_rate' })] = chartData[item].bookRate;
        data.push(obj);
      }
      let cols = {
        day: { range: [0, 1] }
      };
      cols[intl.formatMessage({ id: 'used_rate' })] = { min: 0 };
      return (
        <div className="roomChart">
          <div className="roomDetailTitle">
            {intl.formatMessage({ id: 'report_used_info' })}
          </div>
          <Chart
            style={{ color: 'red' }}
            height={320}
            data={data}
            scale={cols}
            forceFit
            padding={[10, 60, 60, 60]}
          >
            <Axis name="day" label={{ textStyle: { fill: '#333' } }} />
            <Axis
              name={intl.formatMessage({ id: 'used_rate' })}
              label={{ textStyle: { fill: '#333' } }}
            />
            <Tooltip
              crosshairs={{ type: 'y' }}
              // itemTpl={itemTpl}
            />
            <Geom
              type="line"
              position={`day*${intl.formatMessage({ id: 'used_rate' })}`}
              size={2}
            />
            <Geom
              type="point"
              position={`day*${intl.formatMessage({ id: 'used_rate' })}`}
              size={4}
              shape={'circle'}
              style={{ stroke: '#333', lineWidth: 1 }}
            />
          </Chart>
        </div>
      );
    };
    return (
      <div className="message-body roomDetail room-report-detail-container">
        <div className="messages-first roomDetailHeader">
          <div className="nav">
            {/*<a>
              <FormattedMessage id="report_abnormal_statis_report" />
              &nbsp;/&nbsp;
              <FormattedMessage id="report_abnormal_meeting_detail" />
            </a>*/}
          </div>
          <button
            onClick={() => {
              dispatch(
                routerRedux.push(
                  `${PATH_HOME}roomAbnormallyReport?detail=true`
                )
              );
            }}
          >
            <FormattedMessage id="report_abnormal_back" />
          </button>
        </div>
        <Spin spinning={loading} size="large">
          <div
            className="messages-list"
            style={{ height: 800 }}
          >
            <div className="roomDetailName">
              {zoneName +
                ' ' +
                roomName +
                ' ' +
                intl.formatMessage({ id: 'report_room_detail_page' })}
            </div>
            {chartTop()}
            {chartBottom()}
          </div>
        </Spin>
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/components/report/RoomReportAbnormallyDetail.js